import app from 'app.js';

import './footer/footer';

export default app.name;
